<template>
  <div class="material-detail-container">
    <div
      v-if="infoDetail"
      class="material-detail-content"
      :class="{
        'single-material-container': infoDetail && !infoDetail.need_invite,
      }"
    >
      <img class="KV-image" :src="infoDetail.image_url" alt="" />
      <template v-if="infoDetail.need_invite">
        <div class="material-share-content flex-column-center">
          <div class="title" v-html="shareBlockTitle"></div>
          <div class="invitation-content flex-center">
            <template v-if="invitationUserData && invitationUserData.users">
              <img
                v-for="(item, index) in invitationUserData.users"
                :key="`avatar-${index}`"
                :src="item.avatar"
                alt=""
              />
            </template>
            <div
              v-for="(_, index) in shareCount"
              :key="index"
              class="invitation-item flex-center"
              @click="handleClickShare"
            >
              <i class="iconfont iconplus"></i>
            </div>
          </div>
          <button v-if="invitationCount < 3" class="invitation-btn" @click="handleClickShare">
            {{
              infoDetail.self_invitation || !shareId
                ? '邀请好友免费领'
                : '帮 TA 拿资料'
            }}
          </button>
        </div>
        <div
          v-if="
            invitationUserData &&
            invitationUserData.users &&
            invitationUserData.users.length &&
            invitationUserData.file_url
          "
          class="material-share-content flex-column-center share-content"
        >
          <div class="title">我的资料</div>
          <div class="sub-title">复制链接前往浏览器下载</div>
          <div class="content flex-between">
            <div class="flex-start">
              <img
                src="https://logo.wondercv.com/banners/2qa43oDgQXhcmTk.png"
                alt=""
              />
              <div class="detail-title">{{ infoDetail.title }}</div>
            </div>
            <div class="copy-btn flex-center" @click="handleClickCopy">
              复制链接
            </div>
          </div>
          <div class="content flex-between">
            <div class="flex-start">
              <img
                src="https://logo.wondercv.com/banners/2qa43oDgQXhcmTk.png"
                alt=""
              />
              <div class="detail-title">全部求职资料</div>
            </div>
            <div
              class="copy-btn flex-center"
              :class="{ disabled: invitationCount < 3 }"
              @click="handleToList"
            >
              <i v-if="invitationCount < 3" class="iconfont iconsuoding"></i>
              {{ invitationCount === 3 ? '前往查看' : '待解锁' }}
            </div>
          </div>
        </div>
      </template>
      <div
        class="material-share-content flex-column-center detail-content"
        :class="{
          'single-detail-content': infoDetail && !infoDetail.need_invite,
        }"
      >
        <div class="title">详情</div>
        <img :src="infoDetail.info_url" alt="" />
      </div>
      <w-share-wx
        :state="shareState"
        @handleClose="shareState = false"
      ></w-share-wx>
    </div>
    <share-progress-dialog
      v-if="progressDialogState"
      :progress="progressType"
      @handleClose="progressDialogState = false"
      @handleClickBtn="handleClickDialogBtn"
    ></share-progress-dialog>
    <div v-if="infoDetail && !infoDetail.need_invite" class="propaganda-bottom">
      <div class="btn-item" @click="handleToMoreMaterial">更多资料</div>
      <div class="btn-item" @click="handleCopyFileUrl">立即领取</div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { envMixin, loginMixin } from '../../assets/js/mixin/global'
import { toLogin, copyToClipboard } from '../../assets/js/utils'
import { componentsMixin } from '../../assets/js/mixin/components'
import WShareWx from '../../components/global/w-share-wx'
import ShareProgressDialog from './components/share-progress-dialog'

let saveUserTimer;

export default {
  data() {
    return {
      logged: false,
      infoDetail: null,
      invitationId: '',
      invitationUserData: null,
      shareState: false,
      shareId: this.$route.query.invitationId,
      progressDialogState: false,
      progressType: 'single',
    }
  },
  mixins: [envMixin, componentsMixin, loginMixin],
  components: {
    WShareWx,
    ShareProgressDialog,
  },
  computed: {
    shareCount() {
      if (!this.invitationUserData || !this.invitationUserData.users) {
        return 1
      } else if (this.invitationUserData.users) {
        return 3 - this.invitationUserData.users.length
      }
    },
    shareBlockTitle() {
      if (
        !this.invitationUserData ||
        (this.invitationUserData && !this.invitationUserData.users)
      ) {
        return `邀请 1 位好友解锁当前资料`
      } else if (this.invitationUserData.users.length === 3) {
        return `<span style="color: #ff6644;">恭喜你！</span>已解锁全部资料`
      } else if (this.invitationUserData.users) {
        return `再邀请 ${this.shareCount} 位好友解锁全部资料`
      }
    },
    invitationCount() {
      return this.invitationUserData
        ? (this.invitationUserData.users && this.invitationUserData.users.length || 0)
        : 0
    },
  },
  methods: {
    handleToList() {
      if (this.invitationCount === 3) {
        this.$router.push('/campaign/materials/list')
      }
    },
    async verifyLogged() {
      if (Cookies.get('_t') || Cookies.get('_t_plugin')) {
        this.logged = true
      }
    },
    handleToMoreMaterial() {
      this.$router.push('/campaign/materials/list')
    },
    handleClickDialogBtn() {
      switch (this.progressType) {
        case 'single':
        case 'unlock':
          this.handleClickCopy()
          break
        case 'all':
          this.handleToMoreMaterial()
          break
      }

      this.progressDialogState = false
    },
    handleToLogin() {
      if (this.isWxMini) {
        this.$wechat.miniProgram.navigateTo({
          url: `/pages/login/login`,
        })
      } else {
        toLogin(null, 'campaign')
      }
    },
    async handleCopyFileUrl() {
      if (!this.logged) {
        this.handleToLogin()
      } else {
        this.handleClickCopy(true)
      }
    },
    async handleClickShare() {
      if (!this.logged) {
        this.handleToLogin()
      } else {
        const url = `${window.location.origin}${
          window.location.pathname
        }?invitationId=${this.invitationId || ''}`

        if (this.isWxMini) {
          this.shareState = true
        } else {
          await copyToClipboard(url)
          this.showToast('链接已复制，请直接粘贴分享好友')
        }

        this.$wechat &&
          this.$wechat.miniProgram.postMessage({
            data: {
              shareData: {
                title: `精选攻略点击免费领！`,
                path: url,
                imageUrl:
                  'https://logo.wondercv.com/banners/qB6E1gIpW89w3uq.png',
              },
            },
          })
      }
    },
    async getInvitationId() {
      const { id } = this.$route.params
      const { code, data } = await this.$api.campaign.getInvitationId({
        info_id: id,
      })
      if (code === 1000) {
        this.invitationId = data.invitation_id
      }
    },
    async getConfigurationDetailData() {
      try {
        let payload = {}
        if (this.shareId) payload.invitation_id = this.shareId
        const { id } = this.$route.params
        const { code, data } = await this.$api.campaign.getConfigurationDetail(
          id,
          payload
        )
        if (code === 1000) {
          this.infoDetail = data
          this.initShare()
        }
      } catch (error) {
        console.error(`get configuration detail data`, error)
      }
    },
    async getInvitationsData() {
      try {
        const { id } = this.$route.params
        const { code, data } =
          await this.$api.campaign.getConfigurationInvitations({ info_id: id })
        const materialDialogStatus =
          this.$db.ls.get('materialDialogStatus') || {}
        if (code === 1000) {
          this.invitationUserData = data
          const shareProgress = this.saveDialogStatus()
          if (
            shareProgress === 'singleShare' &&
            !materialDialogStatus.singleShare &&
            this.invitationUserData.file_url
          ) {
            this.progressType = 'single'
            this.progressDialogState = true
          } else if (
            shareProgress === 'moreShare' &&
            !materialDialogStatus.moreShare
          ) {
            this.progressType = 'all'
            this.progressDialogState = true
          }
        }
      } catch (error) {
        console.error(`get invitations data error`, error)
      }
    },
    saveAccpetShare(id) {
      if (!id) return
      const accpetShare = this.$db.ls.get('accpetShare') || []
      if (accpetShare.includes(id)) return
      accpetShare.push(id)
      this.$db.ls.set('accpetShare', accpetShare)
    },
    async handleAccpetShare(id) {
      try {
        if (!id) return console.log(`invitation id is undefined!`)

        const { code, message } = await this.$api.campaign.updateInvitationData(
          {
            invitation_id: id,
          }
        )

        if (code === 1000) {
          this.showToast('助力成功')
          this.getInvitationsData()
        } else {
          this.showToast(message)
        }

        saveUserTimer = setTimeout(() => {
          if (code === 1000 || code === 110001) {
            this.saveAccpetShare(id)
            window.history.replaceState(
              null,
              null,
              location.origin + location.pathname
            )
            this.shareId = ''
          }
        }, 2000)
      } catch (error) {
        console.log(error)
      }
    },
    saveDialogStatus() {
      const { users, file_url } = this.invitationUserData || {}
      if (!users) return
      const materialDialogStatus = this.$db.ls.get('materialDialogStatus') || {}
      if (users.length === 1 && file_url) {
        materialDialogStatus.singleShare = 1
        this.$db.ls.set('materialDialogStatus', materialDialogStatus)
        return 'singleShare'
      }
      if (users.length === 3 && file_url) {
        materialDialogStatus.moreShare = 1
        this.$db.ls.set('materialDialogStatus', materialDialogStatus)
        return 'moreShare'
      }
    },
    initShare() {
      this.$route.meta.shareByWx(`精选攻略点击免费领！`, {
        title: `${this.infoDetail.title}`,
        imgUrl: 'https://files.wondercv.com/App%20Icon@2x.png',
      })
    },
    async handleClickCopy(skipCopy) {
      if (!this.invitationUserData || !this.invitationUserData.file_url) return

      if (skipCopy) {
        this.progressType = 'unlock'
        this.progressDialogState = true
      }

      if (!skipCopy) {
        await copyToClipboard(this.invitationUserData.file_url)
        this.showToast('复制成功', 2000)
      }
    },
  },
  async created() {
    await this.miniprogramAutoLogin()
    await this.verifyLogged()
    this.getConfigurationDetailData()
    const accpetShare = this.$db.ls.get('accpetShare') || []
    if (this.logged) {
      this.getInvitationId()
      await this.getInvitationsData()
      const { invitationId } = this.$route.query
      if (!!invitationId && !accpetShare.includes(+invitationId) && (this.invitationUserData && !this.invitationUserData.file_url)) {
        this.handleAccpetShare(+invitationId)
      } else if (!!invitationId) {
        window.history.replaceState(
          null,
          null,
          location.origin + location.pathname
        )
        this.shareId = ''
      }
    }
  },
  beforeDestroy() {
    clearTimeout(saveUserTimer)
  }
}
</script>
<style scoped lang="scss">
@import '../../assets/scss/global/mixin.scss';
.material-detail-container {
  .material-detail-content {
    min-height: 100vh;
    background-color: #f6f7fb;
    @include ipx-content-bottom(10px);
    .KV-image {
      width: 100vw;
      height: 200px;
      object-fit: cover;
    }
    .material-share-content {
      position: relative;
      z-index: 1;
      padding: 32px 0;
      border-radius: 14px;
      background-color: #fff;
      width: calc(100vw - 24px);
      margin: -20px auto 12px;
      .title {
        font-size: 18px;
        color: #303546;
        font-weight: 500;
        margin-bottom: 32px;
      }
      .invitation-content {
        img {
          width: 64px;
          height: 64px;
          object-fit: cover;
          border: 1px solid #ff6644;
          border-radius: 50%;
        }
        .invitation-item {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          border: 2px dashed #ff6644;
          .iconfont {
            font-weight: 500;
            font-size: 30px;
            color: #ff6644;
          }
        }
        img,
        .invitation-item {
          &:not(:last-child) {
            margin-right: 24px;
          }
        }
      }
      .invitation-btn {
        width: calc(100% - 96px);
        height: 46px;
        border-radius: 24px;
        background: linear-gradient(to right, #ff9f79, #ff6644);
        color: #fff;
        font-size: 18px;
        font-weight: 500;
        outline: none;
        border: none;
        margin-top: 32px;
      }
    }
    .share-content {
      margin: 0 auto 12px;
      .title {
        margin-bottom: 8px;
      }
      .sub-title {
        font-size: 14px;
        color: #909090;
        line-height: 20px;
        margin-bottom: 16px;
      }
      .content {
        width: calc(100% - 44px);
        height: 56px;
        border-radius: 8px;
        background-color: #f4f4f4;
        padding: 0 18px;
        box-sizing: border-box;
        &:last-child {
          margin-top: 12px;
        }
        img {
          width: 14px;
          height: 16px;
          margin-right: 6px;
          object-fit: cover;
        }
        .detail-title {
          color: #303546;
          font-weight: 500;
        }
        .copy-btn {
          width: 88px;
          height: 28px;
          background: linear-gradient(to right, #ff9f79, #ff6644);
          border-radius: 14px;
          color: #fff;
          i {
            margin-right: 4px;
          }
          &.disabled {
            background: #a9a9a9;
          }
        }
      }
    }
    .detail-content {
      margin: 0 auto;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
    .single-detail-content {
      margin: -20px auto 12px;
    }
  }
  .propaganda-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 10px 24px;
    @include ipx-content-bottom(10px);
    background-color: #fff;
    z-index: 9;
    .btn-item {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #ff6644;
      width: 108px;
      height: 42px;
      color: #ff6644;
      font-weight: 500;
      border-radius: 22.5px;
      &:nth-child(2) {
        width: 207px;
        margin-left: 12px;
        background: linear-gradient(to right, #ff9f79, #ff6644);
        color: #fff;
        border-color: transparent;
      }
    }
  }
}
.single-material-container {
  @include ipx-content-bottom(72px);
}
</style>
